<template>
  <v-dialog v-model="billingSettingDialog" max-width="600">
    <v-card v-if="billingSettingDialog">
      <v-form @submit.prevent="onSubmit()" ref="form">
        <v-card-title class="green white--text">{{ $t('payment.adjust_service_cost_or_rent') }}</v-card-title>
        <v-card-text class="py-5">
          <span>{{ $t('payment.select_list_to_adjust_price') }}</span>
          <v-select
            :label="$t('select_list')"
            v-model="selectProduct"
            :rules="[rules.required]"
            :disabled="isLoading"
            :items="billingSettingProductDatas"
            :item-text="(r) => `[${r.accountingProduct.typeString}] ${r.accountingProduct.name} @${r.accountingProduct.unit}`"
            :item-value="(r) => r"
            background-color="grey lighten-4"
            flat
            solo
            :no-data-text="$t('noinfo')"
          ></v-select>
          <v-row class="d-flex" v-if="selectProduct">
            <v-col cols="12">
              <div>{{ $t('payment.select_adjust_price_type') }}</div>
              <v-btn-toggle
                v-model="condition"
                mandatory
                borderless
                active-class="text-decoration-underline"
              >
                <v-btn value="plus" :disabled="isLoading" active-class="green--text">{{ $t('increase') }}(+)</v-btn>
                <v-btn value="minus" :disabled="isLoading" active-class="red--text">{{ $t('decrease') }}(-)</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="12">
              <div>{{ $t('payment.select_calculate_type') }}</div>
              <v-btn-toggle
                v-model="addType"
                :color="condition == 'plus'?'success':'error'"
                mandatory
                borderless
                active-class="text-decoration-underline"
              >
                <v-btn
                  value="cost"
                  :disabled="isLoading"
                >{{condition == 'plus'? $t('increase'):$t('decrease')}}{{ $t('payment.amount_of_money') }}({{ $helper.currencySign(tabType) }})</v-btn>
                <v-btn
                  value="percent"
                  :disabled="isLoading"
                >{{condition == 'plus'?$t('increase'):$t('decrease')}}{{ $t('payment.percent') }}</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="6" v-if="addType == 'cost'">
              <div class="d-flex justify-space-between">
                <span>
                  {{ $t(condition == 'plus' ? 'increase' : 'decrease') }} {{ $t('payment.from_original') }} ({{ $helper.currencySign(tabType) }})
                </span>
              </div>
              <v-currency-field
                class="input-right"
                :label="$t('payment.amount_of_money_to_adjust', {condition: condition == 'plus'? $t('increase'): $t('decrease')})"
                v-model="cost"
                :rules="[rules.minCost]"
                :disabled="isLoading"
                background-color="grey lighten-4"
                flat
                solo
              />
            </v-col>
            <v-col cols="6" v-else-if="addType == 'percent'">
              <div class="d-flex justify-space-between">
                <span>
                  {{ $t(condition == 'plus' ? 'increase' : 'decrease') }} {{ $t('payment.from_original') }} (%)
                </span>
              </div>
              <v-currency-field
                class="input-right"
                :label="$t('payment.amount_of_percent_to_adjust', {condition: condition == 'plus' ? $t('increase') : $t('decrease')})"
                v-model="percent"
                :rules="[rules.minPercent, condition !='plus' ? rules.maxPercent : true]"
                :disabled="isLoading"
                required
                background-color="grey lighten-4"
                flat
                solo
              />
            </v-col>
            <v-col cols="12">
              <div>{{ $t('payment.rounding_format') }}</div>
              <v-btn-toggle v-model="isRound" mandatory borderless>
                <v-btn :value="true" :disabled="isLoading">{{ $t('payment.no_decimal') }}</v-btn>
                <v-btn :value="false" :disabled="isLoading">{{ $t('payment.two_decimal') }}</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mx-2 bg-white">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            elevation="0"
            @click="billingSettingDialog = false"
            :disabled="isLoading"
          >
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" elevation="0" type="submit" :disabled="isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "FormAddCost",
  computed: {
    ...mapGetters({
      projectId: "markets/getProjectId"
    }),
    billingSettingDialog: {
      get() {
        if (this.value) {
          this.selectProduct = null;
          this.addType = "cost";
          this.condition = "plus";
          this.isRound = true;
          this.cost = 0;
          this.percent = 0;
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    billingSettingProductDatas() {
      let data = [];
      if (this.billingSettings) {
        for (const objectId in this.billingSettings) {
          let dp = data.find(
            d =>
              d.accountingProductId ==
              this.billingSettings[objectId].accountingProductId
          );
          if (!dp) {
            data.push(this.billingSettings[objectId]);
          }
        }
      }
      return data;
    }
  },
  data() {
    return {
      selectProduct: null,
      addType: "cost",
      condition: "plus",
      isRound: true,
      cost: 0,
      percent: 0,
      isLoadingPrice: false,
      rules: {
        required: value => !!value || this.$t('validate.please_select_list'),
        maxPercent: v => v <= 100 || this.$t('validate.please_max_percent'),
        minPercent: v => v > 0 || this.$t('validate.please_min_percent'),
        minCost: v => v > 0 || `${this.$t('validate.please_min_cost', {currencySign: this.$helper.currencySign(this.tabType)})}`
      }
    };
  },
  props: {
    value: Boolean,
    billingSettings: Object,
    isLoading: Boolean,
    tabType: {
      type: String,
      default: function() {
        return this.$globalCurrencyCode
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.onSave();
      }
    },
    onSave() {
      let tCost =
        this.condition == "plus"
          ? parseFloat(this.cost)
          : parseFloat(this.cost) * -1;
      let tPercent =
        this.condition == "plus"
          ? parseFloat(this.percent)
          : parseFloat(this.percent) * -1;
      this.$emit("onSave", {
        selectProduct: this.selectProduct,
        addType: this.addType,
        cost: tCost,
        percent: tPercent,
        isRound: this.isRound,
        condition: this.condition
      });
    },
    newCost(cost) {
      let newCost = 0;
      if (this.addType == "cost") {
        newCost = cost + parseFloat(this.cost);
      } else if (this.addType == "percent") {
        newCost = cost + (cost * parseFloat(this.percent)) / 100;
      }
      return newCost;
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: auto;
}
</style>
<style>
.small-radio label {
  font-size: 14px;
}
</style>